import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "consent-banner",
  "data-qe-id": "consent-banner"
}
const _hoisted_2 = { class: "description" }
const _hoisted_3 = { class: "buttons" }

import { onMounted } from 'vue'
import { ACTION } from '@gd/tracking'
import { postSettings } from '../lib/request'
import { track } from '../lib/track'
import { events } from '@gd/event-bus'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsentBanner',
  emits: ['on-settings', 'close'],
  setup(__props, { emit }) {



onMounted(() => {
  track({
    id: 'consent_banner',
    action: ACTION.show,
  })
})

function onAcceptClick() {
  post({ functional: true, marketing: true })
  track({
    id: 'consent_banner',
    elem: 'button_consent_all',
    action: ACTION.click,
  })
}

function onSettingsClick() {
  emit('on-settings')
  track({
    id: 'consent_banner',
    elem: 'button_visit_settings',
    action: ACTION.click,
  })
}

function onRejectAll() {
  post({ functional: false, marketing: false })
  track({
    id: 'consent_banner',
    elem: 'button_reject_all',
    action: ACTION.click,
  })
}

function post(data: { functional: boolean; marketing: boolean }) {
  postSettings(data)
    .then(() => {
      events.$emit('cookie-consent', data)
      emit('close')
    })
    .catch(() => {
      emit('close')
    })
}

return (_ctx: any,_cache: any) => {
  const _component_t_button = _resolveComponent("t-button")!
  const _component_t_text = _resolveComponent("t-text")!
  const _component_t_container = _resolveComponent("t-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_t_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('cookieConsent.footer.text')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_t_button, {
            class: "accept-all",
            onClick: onAcceptClick,
            midGreen: "",
            "data-qe-id": "button-accept"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cookieConsent.footer.button_accept_all')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_t_button, {
            class: "settings",
            onClick: onSettingsClick,
            yellow: "",
            "data-qe-id": "button-settings"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cookieConsent.footer.button_2')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_t_text, {
            center: "",
            class: "link-reject"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", { onClick: onRejectAll }, _toDisplayString(_ctx.$t('cookieConsent.footer.button_accept_none')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})